import { Module } from '@nestjs/common';
import { ExpensesSubCategoryController } from './expenses-sub-category.controller';
import { ExpensesSubCategoryService } from './expenses-sub-category.service';
import {ExpensesSubCategory} from './expenses-sub-category.entity';
import { TypeOrmModule } from '@nestjs/typeorm';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { ExpensesSubCategoryAdapter } from './dto/expenses-sub-category.adapter';
import { LogsService } from '@gtpl/shared-services/user-logs';

@Module({

  imports: [
    
    TypeOrmModule.forFeature([ExpensesSubCategory]),
    // forwardRef(() => ClusterModule),
  ],
  controllers: [ExpensesSubCategoryController],
  providers: [ExpensesSubCategoryService,ExpensesSubCategoryAdapter,ApplicationExceptionHandler,LogsService],
  exports: [ExpensesSubCategoryService]
})
export class ExpensesSubCategoryModule {}
